// extracted by mini-css-extract-plugin
export var fadeIn = "_co-1";
export var modalContent = "_co-3";
export var overlay = "_co-0";
export var popoverContent = "_co-2";
export var results = "_co-5";
export var searchInputWrapper = "_co-4";